module.exports = __webpack_public_path__ + "media/img/pages/profile/lidl ger 7-8034d5cbfe5c37a736bd8a650f2d6f44.jpg";